export const menuCategories = [
  {
    icon: 'fa-solid fa-mug-hot',
    title: 'Topli napitki',
    items: [
      'Kava',
      'Kava z mlekom',
      'Kava brez kofeina',
      'Kava z mlekom brez kofeina',
      'Latte Macchiatto',
      'Mala bela kava',
      'Bela kava',
      'Bela kava brez kofeina',
      'Cappuccino',
      'Cappuccino brez kofeina',
      'Cappuccino Guma',
      'Kakav',
      'Vroča čokolada',
      'Čaj',
      'Kuhano vino belo',
      'Kuhano vino rdeče',
      'Med',
      'Mleko, Smetana',
      'Limona',
    ],
  },
  {
    icon: 'fa-solid fa-glass-water',
    title: 'Brezalkoholne pijače',
    items: [
      'Cedevita',
      'Coca Cola, Fanta, Eksotik',
      'Coca Cola, Pepsi, Cockta (steklenica)',
      'Fanta, Sprite, Schweppes (steklenica)',
      'Jabolko, Jagoda, Breskev, Juice',
      'Sok Fructal, Ledeni čaj (steklenica)',
      'Radenska (steklenica)',
      'Orangina',
      'Limonada',
      'Radenska',
      'Romerguelle, Voda z okusom ali brez',
      'Red Bull, Shark',
      'Ora Orange',
    ],
  },
  {
    icon: 'fa-solid fa-wine-glass',
    title: 'Vina',
    items: [
      'Domače vino "S totega brega"',
      'Cviček, Haložan, Janževec, Jeruzalemčan',
      'Refošk',
      'Refošk sladki',
      'Rumeni muškat',
      'Hugo',
      'Martini',
    ],
  },
  {
    icon: 'fa-solid fa-smoking',
    title: 'Cigareti in ostalo',
    items: [
      'Boss, Filter 57, Glamour Amber',
      'Marlboro',
      'Marlboro Touch, West',
      'Jade la Rose',
      'Lucky Strike Aqua',
      'Davidoff Reach',
      'Lucky Strike Aqua Resized',
      'Winston x-style',
      'Terea, Levia',
      'Žvečilne, Vžigalnik',
    ],
  },
  {
    icon: 'fa-solid fa-beer-mug-empty',
    title: 'Piva',
    items: [
      'Union Točeno',
      'Union Točeno',
      'Union Točeno',
      'Union Točeno',
      'Heineken točeno',
      'Heineken točeno',
      'Heineken točeno',
      'Union, Zlatorog',
      'Union, Zlatorog',
      'Ožujsko',
      'Kozel temno',
      'Uni brezalkoholno',
      'Heineken brezalkoholni',
      'Malt',
      'Radler',
      'Radler temni',
      'Heineken',
      'Corona',
      'Smile',
      'Salitos',
    ],
  },
  {
    icon: 'fa-solid fa-whiskey-glass',
    title: 'Žgane pijače',
    items: [
      'Borovničevc, Amaro',
      'Cynar, Sambuca',
      'Pelinkovec, 1000 Roža',
      'Rum, Travarica, Encijan',
      'Wechia Brandy, Vinjak',
      'Viljamovka, Stroh, Shanky',
      'Tequila, Gin Pink',
      'Bacardi',
      'Jagermeister, Antique Pelinkovec',
      'Vodka, Puschkin Black',
      'Gin, Rum Captan Morgan',
      'Chivas Regal 18',
      'Malibu, Havana Club',
      'Mandlijeva tequila',
      'Stock, Slivovka',
      'Baileys, Carolans',
      'Liker Mentol, Hruška, Orehovec',
      'Chivas Regal 12',
      'Balantines',
      'Jack Daniels, Cosy Gin',
      'Jack Daniels Single Barrel',
      'Jack Daniels Fire in Apple, Giovanni Vodka',
      'Jack Daniels Gentleman',
      'Jameson',
      'Canadian Club',
      'Cognac Hennessy, Cognac Martel VSOP',
    ],
  },
];